import React from "react";
import {get as lodashGet} from "lodash";
import {Form} from "react-final-form";
import {Button} from "../../../../components/button/button";
import {globalStyles} from "../../../../css/global.styles";
import {IEditTokensFormValues} from "../../interfaces/forms/editTokens";
import {Textbox} from "../../../../components/textbox/textbox";
import {Header} from "../../../../components/header/header.component";
import {Locations as AdminLocations} from "../../constants/locations";
import {Redirect, useHistory} from "react-router-dom";
import {Container} from "../../../../components/container/container.component";
import {FormFieldWrapper} from "../../../../components/formFieldWrapper/formFieldWrapper.component";
import {ErrorMessage} from "../../../../components/errorMessage";

export function EditTokensComponent(props) {
	const {exchangedData, error, editTokens} = props;
	// const classes = useStyles({});
	const globalClasses = globalStyles({});
	const userId = lodashGet(exchangedData, "userId");

	let history = useHistory();

	const initialValues: IEditTokensFormValues = {
		clientId: "",
		clientKey: "",
	};

	const handleGoBack = () => {
		history.push(AdminLocations.EDIT_USER);
	};

	const handleValidation = (values: IEditTokensFormValues) => {
		const errors: any = {};

		if (!values.clientId) {
			errors.clientId = "To pole jest wymagane";
		}

		if (!values.clientKey) {
			errors.clientKey = "To pole jest wymagane";
		}

		return errors;
	};

	const onSubmit = async (values: IEditTokensFormValues) => {
		editTokens(userId, values.clientId, values.clientKey);
	};

	if (!Object.keys(lodashGet(exchangedData, "formValues", {})).length) {
		return (
			<Redirect
				to={{
					pathname: AdminLocations.USERS,
				}}
			/>
		);
	} else {
		return (
			<Container>
				<Header>
					Edycja tokenów dla {lodashGet(exchangedData, "formValues.login")}
				</Header>
				<Form
					onSubmit={onSubmit}
					validate={handleValidation}
					initialValues={initialValues}
					render={({ handleSubmit, form, submitting, pristine, values }) => {
						return (
							<form onSubmit={handleSubmit} noValidate={true}>
								<FormFieldWrapper>
									<Textbox
										required={true}
										name="clientId"
										label="BDO: Client ID"
										className={globalClasses.inputWidth}
										serverErrors={error}
									/>
								</FormFieldWrapper>
								<FormFieldWrapper>
									<Textbox
										required={true}
										name="clientKey"
										label="BDO: Client Secret"
										className={globalClasses.inputWidth}
										serverErrors={error}
									/>
								</FormFieldWrapper>

								<FormFieldWrapper alignContent="right">
									<Button onClick={handleGoBack} className={globalClasses.centerButton} variant="contained" color="secondary">
										Cofnij
									</Button>
									<Button className={globalClasses.centerButton} variant="contained" color="primary" type="submit" disabled={submitting}>
										Zapisz
									</Button>
								</FormFieldWrapper>

								<ErrorMessage errors={error} type="general" />
							</form>
						);
					}}
				/>
			</Container>
		);
	}
}



